import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';
import Header from '../Headers/header';
import '../PrivacyPolicy/PrivacyPolicy.css';

export default function DataDeletion() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const isRTL = i18n.dir(i18n.language) === 'rtl';
    const steps = t('dataDeletion.steps', { returnObjects: true });

    return (
        <div className="privacy-page">
            <Header />
            <div className="privacy-container">
                <button className="privacy-back-btn" onClick={() => navigate(-1)}>
                    {isRTL ? <FaArrowRight /> : <FaArrowLeft />}
                    {t('dataDeletion.back')}
                </button>

                <div className="privacy-body">
                    <h1 className="privacy-title">{t('dataDeletion.title')}</h1>
                    <p className="privacy-updated">{t('dataDeletion.lastUpdated')}</p>

                    <p className="privacy-intro">{t('dataDeletion.intro')}</p>

                    <hr className="privacy-divider" />

                    <h2 className="privacy-section-heading">{t('dataDeletion.howToTitle')}</h2>

                    {Array.isArray(steps) && steps.map((step, index) => (
                        <div key={index} className="privacy-section">
                            <h2>{step.title}</h2>
                            <p>{step.content}</p>
                        </div>
                    ))}

                    <hr className="privacy-divider" />

                    <div className="privacy-section">
                        <h2>{t('dataDeletion.whatIsDeletedTitle')}</h2>
                        <p>{t('dataDeletion.whatIsDeletedContent')}</p>
                    </div>

                    <div className="privacy-section">
                        <h2>{t('dataDeletion.timelineTitle')}</h2>
                        <p>{t('dataDeletion.timelineContent')}</p>
                    </div>

                    <hr className="privacy-divider" />

                    <div className="privacy-contact">
                        <h2>{t('dataDeletion.contactTitle')}</h2>
                        <p>{t('dataDeletion.contactText')}</p>
                        <a href="mailto:contact@ghaythapp.com">contact@ghaythapp.com</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
